/*eslint-disable */
import { bus } from '@/main';
export default {
  name: 'delete-event-data-popup',
  components: {},
  props: ['deleteEventID'],
  data () {
    return {
      isSubmitted:false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    getEventListAgainMethod(){
      this.$store.dispatch('getEventListAction')
    },
    confirmEvtDeletePopupMethod(){
        this.isSubmitted = true
        this.$store.dispatch('deleteEventInfoAction', {id:this.deleteEventID}).then((res) => {
          this.getEventListAgainMethod();
          this.closeEvtDeletePopupMethod();
          this.isSubmitted = false
        }).catch((err) => {
          this.isSubmitted = false
        })
    },
    closeEvtDeletePopupMethod(){
      bus.$emit('deleteEventPopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
  }
}


